'use strict';

import React from 'react'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'
import Link   from '@Pure/Link'
import Logo   from '@Pure/Logo'

import _ from 'lodash'

import { safeNumeral } from '@root/utility'

const numeral = window.numeral;

numeral.locale('en');

export default class ECProductAbondementsPage extends React.Component
{
	constructor (props)
	{
		super();

		this.state =
		{
			loading: false,
			abondements: [],
			products: []
		};

		this.handleSessionChange = this.handleSessionChange.bind(this);
		this.fetchProducts       = this.fetchProducts.bind(this);
	}

	componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.resetFunctions();

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		})

		component.handleSessionChange();
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	fetchProducts (abondements)
	{
		const component = this, props = this.props, state = this.state;

		let ids = [], state_ids = state.products.map(data => data.id);

		abondements.forEach(function (abondement)
		{
			abondement.products.forEach(function (product_id)
			{
				if (state_ids.includes(product_id) === false)
				{
					ids.push(product_id);
				}
			});
		});

		component.setState(
		{
			loading: true
		});

		qwest.post('/CMS/getAll',
		{
			model: 'product',
			filter_query: JSON.stringify(
			{
				id: ids
			})
		})
		.then(function (xhr, response)
		{
			response.data.forEach(function (product)
			{
				state.products.push(product);
			});

			component.setState(
			{
				products: state.products,
				loading: false
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);

			component.setState(
			{
				loading: false
			});
		});
	}

	handleSessionChange ()
	{
		const component = this, props = this.props, state = this.state;

		if (!app.state.session.EC || !app.state.session.EC.id) return;

		if (state.abondements.length > 0) return;

		component.setState(
		{
			loading: true
		});

		qwest.post('/CMS/getAll',
		{
			model: 'abondement',
			filter_query: JSON.stringify(
			{
				EC: app.state.session.EC.id,
				type: 'product'
			})
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				abondements: response.data,
				loading: false
			});

			component.fetchProducts(response.data);
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);

			component.setState(
			{
				loading: false
			});
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let loader;

		if (component.state.loading === true)
		{
			loader =
			(
				<div className="u-full-width">

					<div className="u-margin-top-10 u-margin-bottom-10">

						<Loader className="c-loader" bemit={ ['primary', 'bg-white', 'big'] } />

					</div>

				</div>
			);
		}

		let abondements = state.abondements.map(function (abondement)
		{
			let amount = numeral(safeNumeral(abondement.value));

			let recurrence = abondement.recurrence;

			if (recurrence === 'month')
			{
				recurrence = 'Au mois';
			}
			else if (recurrence === 'year')
			{
				recurrence = 'À l\'année';
			}
			else
			{
				recurrence = 'Aucun';
			}

			let products = abondement.products.map(function (product_id)
			{
				return state.products.find(data => data.id === product_id);
			})
			.filter(product => typeof product !== 'undefined')
			.map(function (product, key)
			{
				let name = key === 0 ? '' : ', ';

				name += product.name;

				return name;
			});

			let output =
			(
				<div className="c-data-row c-data-row--v2 c-data-row--clickable"
					key={ abondement.id }>

					<li className="o-grid__item c-data-row__item">
						<span className="u-flex">
							{ products }
						</span>

						<Link className="u-link-only"
							href={ '/espace-administrable/abondements-produit/' + abondement.id }>
						</Link>
					</li>

					<li className="o-grid__item c-data-row__item">
						<span className="u-flex">
							{ amount.format('0[.]00') + ' €' }
						</span>

						<Link className="u-link-only"
							href={ '/espace-administrable/abondements-produit/' + abondement.id }>
						</Link>
					</li>

					<li className="o-grid__item c-data-row__item">
						<span className="u-flex">
							{ abondement.qty }
						</span>

						<Link className="u-link-only"
							href={ '/espace-administrable/abondements-produit/' + abondement.id }>
						</Link>
					</li>

					<li className="o-grid__item c-data-row__item">
						<span className="u-flex">
							{ recurrence }
						</span>

						<Link className="u-link-only"
							href={ '/espace-administrable/abondements-produit/' + abondement.id }>
						</Link>
					</li>

				</div>
			);

			return output;
		});

		let output =
		(
			<Layout history={ props.history } page_title="Abondements produit">

				<div className="page-content">

					<HolidaysMessage />

					<div className="u-text-left">
						<Link className="c-btn c-btn--add u-no-margin-top u-margin-bottom-20"
							href="/espace-administrable/abondement-produit">
							Ajouter un abondement produit
						</Link>
					</div>

					<div className="product-abondements-list">
						<div className="c-title c-title--v2 u-no-margin-top">
							<h2 className="c-title__txt">Abondements actifs</h2>
						</div>

						<div className="table-container">

							<div className="c-table">

								<div className="c-data-row c-data-row--v2 c-data-row--header">

									<div className="o-grid__item c-data-row__item">
										Produits
									</div>

									<div className="o-grid__item c-data-row__item">
										Montant
									</div>

									<div className="o-grid__item c-data-row__item">
										Qté / utilisateur
									</div>

									<div className="o-grid__item c-data-row__item">
										Récurrence
									</div>

								</div>

								{ abondements }

							</div>

						</div>

						{ loader }

					</div> { /* /o-grid */ }

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}